import { useLanguage } from "../i18n/LanguageContext";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export const ArticleNaturalDeodorant = () => {
  const { language } = useLanguage();
  const Arrow = language === 'he' ? ArrowLeft : ArrowRight;
  const isRTL = language === 'he';

  const hebrewParagraphs = [
    "בעשור האחרון יותר ויותר אנשים מחפשים דאודורנט טבעי, כזה שעובד באמת, מכיל רכיבים טבעיים, ואינו מבוסס על כימיקלים תעשייתיים אגרסיביים. החיפוש הזה אינו מקרי. הוא נובע מהבנה הולכת וגוברת שהגוף שלנו בא במגע יומיומי עם מוצרי טיפוח, ושבחירה ב־קוסמטיקה טבעית אינה טרנד, אלא החלטה מודעת.",
    "הדאודורנט המוצג כאן נולד מתוך הרצון לייצר דאודורנט ללא אלומיניום, ללא פרבנים וללא בישום כימי, המבוסס על חומרים טבעיים בלבד, עם תהליך פתוח ושקוף שכל אדם יכול להבין, לשחזר ולהתאים לעצמו. זהו דאודורנט טבעי לגברים ולנשים, המתאים לשימוש יומיומי ומיועד לעבוד עם הגוף, לא נגדו.",
    "הפורמולציה מבוססת על חומרי גלם טבעיים איכותיים מהשורה הראשונה: סודיום ביקרבונט (סודה לשתייה באיכות קוסמטית) ממקור איטלקי לייצוב ולספיחת לחות, שעוות דבורים מבריטניה ליציבות ומרקם, שמן קוקוס מסרי־לנקה כבסיס שומני אנטיבקטריאלי טבעי, לצד חמאת שיאה, עמילנים טבעיים, ג'ל אלוורה ושמנים אתריים. כל אחד מהרכיבים נבחר בשל התכונות הטבעיות שלו: ספיחה, איזון pH, ריכוך, יציבות וריח, ולא בשל שיקולי שיווק.",
    "תהליך הפיתוח של הדאודורנט נעשה בעזרת בינה מלאכותית (AI) ככלי עזר מחקרי, ולא כסמכות. ה־AI שימש לניתוח תהליכים קיימים, זיהוי בעיות נפוצות בהכנת דאודורנט ביתי, והבנת הקשר בין מינונים, מרקם, יציבות והפרדת חומרים. כל תובנה נבחנה בפועל, ונוסתה על ידי משתמשים אמיתיים, כחלק מתהליך פתוח ומתועד.",
    "אחד הנושאים החשובים ביותר בהכנת דאודורנט טבעי בבית הוא יציבות החומר. רבים נתקלים בבעיות כמו נזילה, שינוי מרקם או סגרגציה: היפרדות של רכיבים, תופעה נפוצה בקוסמטיקה ביתית. הפורמולציה הזו מתמודדת עם הבעיה באמצעות סדר מסע נכון, איזון מדויק בין שומנים לאבקות, שימוש מבוקר בשעוות דבורים וערבוב נכון של רכיבים יבשים. התוצאה היא דאודורנט במרקם קרמי, יציב ואחיד לאורך זמן.",
    "במקביל, חשוב להבין מה לא נמצא כאן. דאודורנטים מסחריים רבים מכילים חומרים נפוצים בתעשיית הקוסמטיקה כגון מלחים סינתטיים חזקים, חומרים משמרים אגרסיביים, ובישום כימי שמטרתו להסוות ריח ולא לטפל במקורו. חומרים אלו אינם חלק מהגישה שלנו. במקום זאת, אנו משתמשים בתכונות הטבעיות של החומרים עצמם כדי להשיג ניטרול ריח, תחושת יובש נעימה, מרקם מאוזן והימנעות מגירוי.",
    "הידע באתר זה נועד להיות ידע פתוח. כל אדם יכול ללמוד כאן איך להכין דאודורנט טבעי לבד, לעיין ברשימת הרכיבים, להבין את שלבי ההכנה והיישום, ולרכוש את חומרי הגלם בנפרד, בין אם דרכנו ובין אם מחנויות טבע מקומיות. במקביל, קיימת גם אפשרות לרכוש דאודורנט טבעי מוכן לשימוש, המבוסס בדיוק על אותה פורמולציה ואותו תהליך, עבור מי שמעדיף פתרון נוח ומיידי.",
    "חלק בלתי נפרד מהמערכת הוא קהילת המשתמשים. אנשים משתפים תהליכי הכנה, מעלים תמונות, מתארים שינויים שביצעו בפורמולציה, ומקבלים תגובות ממשתמשים אחרים. תהליכים מוצלחים, הערות חוזרות וניסויים מעניינים נאספים ונבחנים, לעיתים גם בעזרת AI, כחלק משיפור מתמשך של הידע, בשקיפות מלאה."
  ];

  const englishParagraphs = [
    "In the last decade, more and more people are looking for natural deodorant, one that actually works, contains natural ingredients, and is not based on aggressive industrial chemicals. This search is not random. It stems from a growing understanding that our body comes into daily contact with care products, and that choosing natural cosmetics is not a trend, but a conscious decision.",
    "The deodorant presented here was born from the desire to create a deodorant without aluminum, without parabens and without chemical fragrance, based solely on natural materials, with an open and transparent process that anyone can understand, replicate and adapt for themselves. This is a natural deodorant for men and women, suitable for daily use and designed to work with the body, not against it.",
    "The formulation is based on premium natural raw materials: sodium bicarbonate (cosmetic-grade baking soda) from an Italian source for stabilization and moisture absorption, beeswax from Britain for stability and texture, coconut oil from Sri Lanka as a natural antibacterial fat base, alongside shea butter, natural starches, aloe vera gel and essential oils. Each ingredient was chosen for its natural properties: absorption, pH balance, softening, stability and scent, and not for marketing considerations.",
    "The deodorant development process was done with the help of artificial intelligence (AI) as a research aid, not as an authority. The AI was used to analyze existing processes, identify common problems in homemade deodorant preparation, and understand the relationship between dosages, texture, stability and material separation. Every insight was tested in practice, and tested by real users, as part of an open and documented process.",
    "One of the most important issues in making natural deodorant at home is material stability. Many encounter problems such as leakage, texture change or segregation: separation of components, a common phenomenon in homemade cosmetics. This formulation deals with the problem through correct loading order, precise balance between fats and powders, controlled use of beeswax and proper mixing of dry ingredients. The result is a deodorant with a creamy, stable and uniform texture over time.",
    "At the same time, it is important to understand what is not here. Many commercial deodorants contain common ingredients in the cosmetics industry such as strong synthetic salts, aggressive preservatives, and chemical fragrance intended to mask odor rather than treat its source. These materials are not part of our approach. Instead, we use the natural properties of the materials themselves to achieve odor neutralization, pleasant dryness, balanced texture and irritation avoidance.",
    "The knowledge on this site is intended to be open knowledge. Anyone can learn here how to make natural deodorant alone, review the ingredient list, understand the preparation and application stages, and purchase the raw materials separately, whether through us or from local health stores. At the same time, there is also an option to purchase ready-to-use natural deodorant, based on exactly the same formulation and the same process, for those who prefer a convenient and immediate solution.",
    "An integral part of the system is the user community. People share preparation processes, upload photos, describe changes they made to the formulation, and receive feedback from other users. Successful processes, recurring comments and interesting experiments are collected and examined, sometimes with the help of AI, as part of continuous knowledge improvement, in full transparency."
  ];

  const closingStatements = {
    he: [
      "זהו אינו קורס, ואינו אתר מכירות אגרסיבי.",
      "זהו מרחב ידע על דאודורנט טבעי, קוסמטיקה טבעית, ויצירה עצמאית של מוצרי טיפוח, המבוסס על חומרים איכותיים, תהליך פתוח ואחריות אישית.",
      "הבחירה אם להכין לבד או לרכוש מוכן, היא שלכם.",
      "הידע נשאר פתוח."
    ],
    en: [
      "This is not a course, and it is not an aggressive sales site.",
      "This is a knowledge space about natural deodorant, natural cosmetics, and independent creation of care products, based on quality materials, an open process and personal responsibility.",
      "The choice whether to make it yourself or buy ready-made, is yours.",
      "The knowledge remains open."
    ]
  };

  const paragraphs = isRTL ? hebrewParagraphs : englishParagraphs;
  const closing = isRTL ? closingStatements.he : closingStatements.en;

  return (
    <div className="min-h-screen pt-20 pb-12 bg-[#FAF8F5] dark:bg-[#0f1510]">
      <SEO page="editorial" />

      {/* Article */}
      <article className="max-w-3xl mx-auto px-4 sm:px-6" style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
        
        {/* Breadcrumb */}
        <nav className="mb-6">
          <Link 
            to="/articles" 
            className="inline-flex items-center gap-2 text-sm text-[#4A5D43] dark:text-[#9ACD8A] hover:underline"
          >
            <ArrowRight className={`h-4 w-4 ${isRTL ? '' : 'rotate-180'}`} />
            {isRTL ? 'חזרה למאמרים' : 'Back to Articles'}
          </Link>
        </nav>

        {/* Magazine Style Header */}
        <header className="mb-10 pb-8 border-b-2 border-[#4A5D43]/20 dark:border-[#4A5D43]/30">
          <p className="text-sm font-medium text-[#4A5D43] dark:text-[#9ACD8A] uppercase tracking-wider mb-4">
            {isRTL ? 'מאמר מערכת' : 'Editorial'}
          </p>
          <h1 className="font-serif text-2xl sm:text-3xl md:text-4xl font-medium text-[#2C3329] dark:text-white leading-tight mb-4">
            {isRTL ? 'על דאודורנט טבעי' : 'About Natural Deodorant'}
          </h1>
          <p className="text-lg text-[#6B7266] dark:text-[#9A9790]">
            {isRTL ? 'ידע פתוח לקוסמטיקה מודעת' : 'Open knowledge for conscious cosmetics'}
          </p>
          <div className="flex items-center gap-4 text-sm text-[#6B7266] dark:text-[#9A9790] mt-4">
            <span>{isRTL ? '5 דקות קריאה' : '5 min read'}</span>
            <span>•</span>
            <span>{isRTL ? "M'ART" : "M'ART"}</span>
          </div>
        </header>

        {/* Lead Paragraph - Magazine Style with Drop Cap */}
        <div className="mb-8">
          <p className="text-lg sm:text-xl leading-relaxed text-[#2C3329] dark:text-[#E8E4DC] font-serif first-letter:text-5xl first-letter:font-bold first-letter:float-right first-letter:mr-0 first-letter:ml-3 first-letter:text-[#4A5D43] dark:first-letter:text-[#9ACD8A]">
            {paragraphs[0]}
          </p>
        </div>

        {/* Article Body */}
        <div className="space-y-6">
          {paragraphs.slice(1).map((paragraph, index) => (
            <p 
              key={index}
              className="text-[#4a4a4a] dark:text-[#c5c5c5] leading-[1.9] text-base"
            >
              {paragraph}
            </p>
          ))}
        </div>

        {/* Decorative Divider */}
        <div className="my-12 flex items-center justify-center">
          <div className="h-px w-16 bg-[#4A5D43]/30"></div>
          <div className="mx-4 w-2 h-2 rounded-full bg-[#4A5D43]"></div>
          <div className="h-px w-16 bg-[#4A5D43]/30"></div>
        </div>

        {/* Closing Statements */}
        <div className="space-y-4 text-center">
          {closing.map((statement, index) => (
            <p 
              key={index}
              className={`${index === closing.length - 1 ? 'font-serif text-2xl text-[#4A5D43] dark:text-[#9ACD8A] font-medium' : 'text-[#2C3329] dark:text-white font-medium'}`}
            >
              {statement}
            </p>
          ))}
        </div>

        {/* Terms Link */}
        <p className="text-center text-sm text-[#6B7266] dark:text-[#9A9790] mt-8">
          {isRTL ? 'לתנאי שימוש ומדיניות פרטיות, ראו את ' : 'For terms of use and privacy policy, see the '}
          <Link to="/terms" className="text-[#4A5D43] dark:text-[#9ACD8A] underline hover:text-[#3A4A35]">
            {isRTL ? 'עמוד התקנון' : 'Terms page'}
          </Link>
          .
        </p>

        {/* CTA */}
        <div className="mt-12 text-center py-8 px-6 bg-gradient-to-b from-[#F5F2EB] to-[#FAF8F5] dark:from-[#1a231a] dark:to-[#0f1510] rounded-2xl border border-[#E8E4DC] dark:border-[#2a3a2a]">
          <p className="font-serif text-2xl text-[#4A5D43] dark:text-[#9ACD8A] font-medium mb-6">
            {isRTL ? 'הידע נשאר פתוח.' : 'The knowledge remains open.'}
          </p>
          <Link 
            to="/diy"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#4A5D43] hover:bg-[#3A4A35] text-white rounded-full font-medium transition-colors"
          >
            {isRTL ? 'לפורמולה המלאה' : 'View Full Formula'}
            <Arrow className="h-4 w-4" />
          </Link>
        </div>

        {/* Back to Articles */}
        <div className="mt-8 text-center">
          <Link 
            to="/articles"
            className="inline-flex items-center gap-2 text-[#4A5D43] dark:text-[#9ACD8A] hover:underline font-medium"
          >
            <ArrowRight className={`h-4 w-4 ${isRTL ? '' : 'rotate-180'}`} />
            {isRTL ? 'חזרה לכל המאמרים' : 'Back to All Articles'}
          </Link>
        </div>
      </article>

      {/* SEO Hidden Content */}
      <div className="sr-only" aria-hidden="true">
        <h1>על דאודורנט טבעי - ידע פתוח לקוסמטיקה מודעת</h1>
        {hebrewParagraphs.map((p, i) => <p key={i}>{p}</p>)}
        {closingStatements.he.map((s, i) => <p key={i}>{s}</p>)}
      </div>
    </div>
  );
};

export default ArticleNaturalDeodorant;
